import { MESSAGE_ERROR_DEFAULT } from '@/app/[locale]/store/_consts/discounts';

import { _getInvalidOrExpiredDiscountError } from './_getInvalidOrExpiredDiscountError';
import type { DiscountError, GetNoDiscount } from './types';

export const _getNoDiscount = ({
  discount,
  invalidReason,
  valid,
}: GetNoDiscount): DiscountError => {
  if (!discount) {
    return {
      errorMessage: MESSAGE_ERROR_DEFAULT,
      invalidReason,
    };
  }

  return _getInvalidOrExpiredDiscountError({
    invalidReason,
    valid,
  });
};
